/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for restore progress.
 */
'use strict';

angular
  .module('services.progress.restore', ['http.progress'])
  .factory('RestoreProgress', function (authFactory, httpProgress, $rootScope, $timeout, PROGRESS_ACTIONS) {
    var delay = 4000,
      poller,
      updateFromProgress,
      // Object used to hold progress data returned from the server.
      progress = {
        restoreInProgress: false,
        restore: {},
        polling: false,

        startPolling: function () {
          if (this.polling !== true) {
            this.polling = true;
            poller();
          }
        },

        stopPolling: function () {
          this.polling = false;
        }
      };

    /**
     * Utility function for processing the progress data array returned by the server.
     *
     * @param {Progress[]} - progressList The array of progress items returned by the server.
     * @returns {Promise} - A promise that resolves when the restoreInProgress value has been set.
     */
    updateFromProgress = function (progressList) {
      var restoreFound = false;

      return authFactory.getSignedRequest().then(function (userInfo) {
        angular.forEach(progressList, function (pItem) {
          pItem.bookmark = JSON.parse(pItem.bookmark);
          pItem.running = true;
          if (pItem.action === PROGRESS_ACTIONS.MAINTENANCE) {
            $rootScope.maintenanceModeFlag = true;
          } else if (
            pItem.action === PROGRESS_ACTIONS.OBJECT_RESTORE &&
            pItem.userId === userInfo.context.user.spanningId
          ) {
            angular.extend(progress.restore, pItem);
            restoreFound = true;
          }
        });

        // Save the update in the inProgress value for the restore after the type has been
        // processed.
        if (restoreFound !== progress.restoreInProgress) {
          progress.restoreInProgress = restoreFound;
        }
      });
    };

    /**
     * A function that will execute that call to get restore progress and continue polling if the
     * polling property is set on the progress object.
     *
     * @returns {Promise} - A promise that will resolve after the initial progress
     * service call is complete and the progress object has been updated.
     */
    poller = function () {
      return httpProgress
        .getProgress()
        .then(function (progressList) {
          return updateFromProgress(progressList);
        })
        .then(function () {
          if (progress.polling) {
            $timeout(poller, delay);
          }
        });
    };

    // execute the poller to gather initial restore progress data.
    poller().then(function () {
      if (progress.restoreInProgress) {
        progress.startPolling();
      }
    });

    return progress;
  });
